<style lang="less" scoped>
    @E9:#E9E9E9;
    @4D:#4D4D4D;
    @68:#6851FF;
    @F25:#E81E1C;
    @333:#333;
    .shopCar{
        width: 100%;
        height: auto;
        .car_head{
            width: 100%;
            height: 40px;
            background-color: #fff;
            line-height: 40px;
            display: flex;
            justify-content:space-between;
            align-items: center;
            box-sizing: border-box;
            padding: 0 10px;
            font-size: 16px;
            // position: fixed;
            top: 0;
            left: 0;
            z-index: 1;
            .return{
                display: flex;
                align-items: center;
            } 
        }
        .content{
            width: 96%;
            margin: 10px auto 0;
            // height: calc(100% - 100px - 7.5vh);
            overflow-y: auto;
            .sp_list{
                width: 96%;
                border-radius: 8px;
                background-color: #fff;
                margin: 0 auto 10px;
                padding: 0px 6px;
                box-sizing: border-box;
                >p{
                    display: flex;
                    align-items: center;
                    padding: 8px 0;
                    label{
                        display: flex;
                        align-items: center;
                    }
                    span{
                        display: inline-block;
                        margin-left: 6px;
                        font-size: 12px;
                        color: #333;
                        font-weight: bold;
                    }
                }
                .product_list{
                    width: 100%;
                    padding-bottom: 10px;
                    display: flex;
                    background-color: #fff;
                    box-sizing: border-box;
                    margin-bottom: 8px;
                    position: relative;
                    border-radius: 8px;
                    .choose{
                        display: flex;
                        align-items: center;
                        margin-right: 6px;
                        height: 125px;
                        label{
                            width: 100%;
                            height: 30px;
                            display: flex;
                            align-items: center;
                        }
                    }
                    .img_infos{
                        display: flex;
                        border-top: 0.5px solid #E0E0E0;
                        padding-top: 9px;
                        width: 100%;
                        .pro_ipn{
                            display: flex;
                            .proImg{
                                width: 116px;
                                height: 116px;
                                border-radius: 8px;
                                overflow: hidden;
                                position: relative;
                                >img{
                                    width: 100%;
                                    height: 100%;
                                }
                                .address{
                                    position: absolute;
                                    bottom: 0;
                                    width:116px;
                                    min-height: 25px;
                                    max-height: 50px;
                                    background:rgba(0,0,0,1);
                                    opacity:0.6;
                                    border-radius:0px 0px 8px 8px;
                                    text-align: center;
                                    // line-height: 25px;
                                    color: #fff;
                                    font-size: 12px;
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                    padding: 4px 5px;
                                    box-sizing: border-box;
                                }
                            }
                            >p{
                                padding: 6px 0;
                                color: @F25;
                                font-weight: bold;
                            }
                            .proImg_ul{
                                width: 650px;
                                display: flex;
                                align-items: center;
                                justify-content: space-around;
                                li{
                                    display: flex;
                                    flex-direction: column;
                                    width: 300px;
                                    font-size: 16px;
                                    color: #515151;
                                    align-items: center;
                                }
                                .proImg_last{
                                    margin-top: 0px;
                                    font-weight: 400;
                                }
                            }
                        }
                        ul{
                            margin-left: 15px;
                            li{
                                color: @4D;
                                font-size: 12px;
                                margin-bottom: 3px;
                                display: flex;
                                align-items: center;
                                &.listOne{
                                    color: #333;
                                    font-size: 14px;
                                    font-weight: bold;
                                }
                                >span{
                                    display: inline-block;
                                    // min-width: 44px;
                                    text-align-last: justify;
                                }
                                >p{
                                    max-width: calc(100% - 44px);
                                    word-break: break-all;
                                    font-size: 14px;
                                }
                            }
                            li:last-child{
                                // display: flex;
                                align-items: center;
                                margin-top: 13px;
                                font-weight: bold;
                                .oldPrice{
                                    color: #999;
                                    font-size: 12px;
                                    text-decoration: line-through;
                                }
                                .nowPrice{
                                    color: @F25;
                                    font-size: 16px;
                                    span{
                                        font-size: 12px;
                                    }
                                }
                            }
                        }
                    }
                    .changeNum{
                        width: 80px;
                        height: 24px;
                        border-radius: 4px;
                        border: 1px solid #666;
                        position: absolute;
                        right: 2px;
                        bottom: 50px;
                        background-color: #fff;
                        display: flex;
                        align-items: center;
                        color: #333;
                        margin-right: 50px;
                        img {
                          width: 10px;
                        }
                        span{
                            display: inline-block;
                            height: 24px;
                            width: 23px;
                            font-size: 16px;
                            font-weight: bold;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            
                            &.reduce{
                                border-right: 1px solid #666;
                            }
                            &.add{
                                border-left: 1px solid #666;
                            }
                        }
                        input{
                            display: inline-block;
                            width: 32px;
                            border: none;
                            outline: none;
                            height: 22px;
                            text-align: center;
                        }
                    }
                    .s_name{
                        position: absolute;
                        right: 14px;
                        top: 10px;
                        color: #F36800;
                        font-size: 14px;
                    }
                }
            }
        }
        .car_footer{
            width: 100%;
            height: 50px;
            background-color: #fff;
            // position: fixed;
            bottom: 0;
            padding: 0 15px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            box-sizing: border-box;
            border-top: 0.5px solid #D3D5D5;
            .foot_left{
                display: flex;
                align-items: center;
                >div{
                    height: 20px;
                }
                span{
                    display: inline-block;
                    height: 24px;
                    // line-height: 24px;
                    margin-left: 8px;
                    font-size: 15px;
                }
            }
            .foot_right{
                display: flex;
                align-items: center;
                justify-content: space-between;
                .total_priceBox{
                    text-align: right;
                    margin-right: 20px;
                    .vip_price{
                        color:#F36800;
                        font-size: 14px;
                        font-weight: bold;
                    }
                    .total_price{
                        color: #999;
                        text-decoration: line-through;
                        font-size: 12px;
                    }
                }
                .buyBtn{
                    width:72px;
                    height:30px;
                    line-height: 30px;
                    text-align: center;
                    color: #fff;
                    font-size: 13px;
                    background: linear-gradient(150deg, #FF923E 0%, #FF6F00 100%);
                    border-radius:15px;
                }
                .deleteBtn{
                    width:72px;
                    height:30px;
                    line-height: 30px;
                    text-align: center;
                    color: #F36800;
                    font-size: 13px;
                    // background:rgba(242,94,94,1);
                    border: 1px solid #F36800;
                    border-radius:15px;
                }
            }
        }
    }
    .checked{
        appearance:none;
	  	width: 16px;
	  	height: 16px;
	  	border: 1px solid #ccc;
	  	border-radius: 50%;
    }
    .checked:checked{
        appearance:none;
	  	width: 16px;
	  	height: 16px;
	  	border: 1px solid #FF7C00;
	  	border-radius: 50%;
	  	background: url('../../assets/confirm.png') #FF7C00 no-repeat center;
	  	background-size: 27px 27px;
        outline: none;
    }
    .checked:focus{
        outline: none !important;
    }
    .manager{
        color: #F58837;
    }
</style>
<template>
    <div class="shopCar">
        <div class="car_head">
            <div class="return" style="width:40px;"></div>
            <!-- @click="goBack" -->
            <!-- <img src="../assets/icon_return.png" alt=""> -->
            <!-- <div>购物车</div> -->
            <div class="manager" @click="manageCar">{{deleteShow?'完成':'管理'}}</div>
        </div>
        <!-- 购物车列表 -->
        <div class="content">
            <div class="sp_list" v-for="(items,index) in handleList" :key="index">
                <!-- <p><label for=""><input class="checked" type="checkbox" :value="items[0].supplier_id" v-model="supplierIds" @click="chooseSupplier(index)"></label><span>{{items[0].supplier_name}}</span></p> -->
                <div class="product_list" v-for="item in items" :key="item.com_id">
                    <div class="choose"><label for=""><input class="checked" type="checkbox" :value="item.id" v-model="userCheckedId" @change="chooseProduct(index,item.id)"></label></div>
                    <div class="img_infos">
                        <div class="pro_ipn">
                            <!-- <div class="proImg" v-if="item.type == 'plank'" @click="toDetail(item.com_ids,item.type,item.supplier_id)">
                                <img :src="item.picture?item.picture[0].url +'?x-oss-process=image/resize,m_fill,h_116,w_116':''" alt="">
                            </div> -->
                            <div class="proImg" v-if="item.type != 'plank'" @click="toDetail(item.com_ids,item.type,item.supplier_id)">
                                <img :src="item.picture?(item.picture[0].url?item.picture[0].url +'?x-oss-process=image/resize,m_fill,h_116,w_116':item.picture[0] +'?x-oss-process=image/resize,m_fill,h_116,w_116'):''" alt="暂无图片">
                            </div>
                            <ul class="proImg_ul" v-if="item.spec">
                                <li>{{item.spec}}</li>
                                <li class="item_part_type">{{
                                        item.part_type == 'shutter' ? '门窗' : 
                                        item.part_type == 'cabinet' ? '柜体' : 
                                        item.part_type == 'furniture' ? '家具' : 
                                        item.part_type == 'woodenDoor' ? '木门' : '其他' 
                                    }}
                                </li>
                                <li class="proImg_last">{{vip==0 ? item.price : item.vip_price}}元</li>
                            </ul>
                            <ul class="proImg_ul" v-else>
                                <li>{{item.name}}</li>
                                <li class="item_part_type">{{
                                        item.part_type == 'shutter' ? '门窗' : 
                                        item.part_type == 'cabinet' ? '柜体' : 
                                        item.part_type == 'furniture' ? '家具' : 
                                        item.part_type == 'woodenDoor' ? '木门' : '其他' 
                                    }}
                                </li>
                                <li class="proImg_last">{{vip==0 ? item.price : item.vip_price}}元</li>
                            </ul>
                        </div>
                        <ul @click="toDetail(item.com_ids,item.type,item.supplier_id)">
                            <li class="listOne" v-if="item.brand || item.substrate"><span>{{item.brand}}</span>&nbsp;&nbsp;<span>{{item.substrate}}</span></li>
                            <li v-for="(tem,temIndex) in setAttributesName(item.type)" :key="temIndex"><span>{{tem.title}}：</span>{{item[tem.option]}}</li>
                            <!-- <li>
                                <div class="nowPrice"><span>￥</span>{{userData.cloud_vip != 0?item.vip_price:item.price}}</div>
                            </li> -->
                        </ul>
                        
                    </div>
                    <div class="changeNum">
                        <span class="reduce" @click="reduceShop(item.id)"><img src="../../assets/icon_decrease.png" alt=""></span>
                        <input type="text" @keyup="getInputNum" :data-id='item.id' :data-value="item.num"  v-model="item.num">
                        <span class="add" @click="addShop(item.id)"><img src="../../assets/icon_crease.png" alt=""></span>
                    </div>
                </div>
            </div>
            <Null v-if="order.length == 0"></Null>
        </div>
        <!-- <div style="width:100%;height:50px;bacground:#F5F5F5"></div> -->
        <!-- 结算 -->
        <div class="car_footer" v-show="!deleteShow">
            <label class="foot_left">
                <div><input class="checked" type="checkbox" @click="checkAll" v-model="checkedAll"></div>
                <span>全选</span>
            </label>
            <div class="foot_right">
                <div class="total_priceBox" v-if="userData.cloud_vip != 0">
                    <div class="vip_price">会员价：￥{{vip_price.toFixed(2)}}</div>
                    <div class="total_price">合计：￥{{all_price.toFixed(2)}}</div>
                </div>
                <div class="total_priceBox" v-if="userData.cloud_vip == 0">
                    <div class="vip_price">合计：￥{{all_price.toFixed(2)}}</div>
                    <div class="total_price">会员价：￥{{vip_price.toFixed(2)}}</div>
                </div>
                <div class="buyBtn" @click="toAccount">结算</div>
            </div>
        </div>
        <!-- 删除 -->
        <div class="car_footer" v-show="deleteShow">
            <label class="foot_left">
                <div><input class="checked" type="checkbox" @click="checkAll" v-model="checkedAll"></div>
                <span>全选</span>
            </label>
            <div class="foot_right">
                <div class="deleteBtn" @click="deleteCar">删除</div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapMutations, mapState } from 'vuex';
import { Toast, Dialog } from 'vant';
import { handleOrderList,handleOrderListNew,handleAttributesName } from '../../util/processingData.js'
import Null from '../../components/Null.vue'
import { json } from 'body-parser/index.js';
export default {
    components:{
        Toast, Dialog,Null
    },
    data(){
        return{
            deleteShow:false,
            userCheckedId:[],
            supplierIds:[],
            checkedAll:false,
            uid:'',
            order:[],
            vip_price:0,
            all_price:0,
            handleList:[],
            vip: 0,
            // userData:{}

        }
    },
    mounted(){
        if(localStorage.data){
            const data_vip = JSON.parse(localStorage.data)
            this.vip = data_vip.vip
            console.log("data",data_vip.vip)
            // this.userData = JSON.parse(localStorage.getItem('data'))
            this.uid = JSON.parse(localStorage.getItem('data')).id
            // 从本地获取购物车数据
            let localCar = localStorage.getItem('shopCarInfo')
            // console.log('localCar',localCar)
            if(localCar){
                this.order = JSON.parse(localCar)[this.uid]
                let list = handleOrderList(this.order)
                this.handleList = list
                console.log('购物车数据', this.handleList)
                // 默认全选
                list.forEach(item => {
                    this.supplierIds.push(item[0].supplier_id)
                })
                this.order.forEach(item => {
                    this.userCheckedId.push(item.id)
                })
            }
        }
    },
    computed: {
        userData(){
            return this.$store.state.userInfo
        },
        setAttributesName(){
            return (type) =>{
                return handleAttributesName(type)
            }
        }
    },
    methods:{
        chooseProduct(index){
            // 选中的商品列表
            let list = this.handleList[index].filter(item => {
                if(this.userCheckedId.indexOf(item.id) != -1){
                    return item
                }
            })
            if(list.length == this.handleList[index].length){
                this.supplierIds.push(this.handleList[index][0].supplier_id)
            }else{
                // 记录选中的供应商id在数组中的位置，删除
                let i = this.supplierIds.indexOf(this.handleList[index][0].supplier_id)
                if(i != -1){
                    this.supplierIds.splice(i,1)
                }
            }
        },
        chooseSupplier(index){
            let p_ids = []
            let nowSupplierId = this.handleList[index][0].supplier_id
            console.log('12222222',this.handleList[index])
            this.handleList[index].forEach(item => {
                console.log("数据",item)
                p_ids.push(item.id)
            })
            if(this.supplierIds.indexOf(nowSupplierId) == -1){
                p_ids.forEach(item => {
                    if(this.userCheckedId.indexOf(item) == -1){
                        this.userCheckedId.push(item)
                    }
                })
            }else{
                let newUserCheckedId = this.userCheckedId.filter(item => {
                    if(p_ids.indexOf(item) == -1){
                        return item
                    }
                })
                this.userCheckedId = newUserCheckedId
            }
        },
        ...mapMutations([
            'showNav','setShopCarNum'
        ]),
        // input手动输入验证
        getInputNum(e){
            let id = e.target.dataset.id
            let newNum = Number(e.target.dataset.value)
            if(!isNaN(newNum)){
                if(newNum <= 0){
                    newNum = 1
                }
                newNum = Math.ceil(newNum)
                let newCar = {}
                this.order.forEach(item => {
                    if(item.id == id){
                        item.num = newNum
                    }
                })
                newCar[this.uid] = this.order
                this.countPrice()
                localStorage.setItem('shopCarInfo',JSON.stringify(newCar))
            }else{
                newNum = 1
                let newCar = {}
                this.order.forEach(item => {
                    if(item.id == id){
                        item.num = newNum
                    }
                })
                newCar[this.uid] = this.order
                this.countPrice()
                localStorage.setItem('shopCarInfo',JSON.stringify(newCar))
            }
            
        },
        countPrice(){
            // 计算价格
            let checkedProduct = this.order.filter(item=>{
                if(this.userCheckedId.indexOf(item.id) != -1){
                    return item
                }
            })
            let vip_cost = 0
            let all_cost = 0
            checkedProduct.forEach(item => {
                vip_cost += (item.num*item.vip_price)
                all_cost += (item.num*item.price)
            })
            this.vip_price = vip_cost
            this.all_price = all_cost
        },
        manageCar(){
            this.deleteShow = !this.deleteShow
        },
        goBack(){
            this.$router.go(-1)
            if(this.$route.query.nav == 1){
                return
            }else{
                this.showNav()
            }
        },
        checkAll(){
            let cL = this.userCheckedId.length
            let cal = this.order.length
            let chl = this.handleList.length
            let csl = this.supplierIds.length
            if(cL === cal || csl === chl){
                this.userCheckedId = []
                this.supplierIds = []
            }else{
                this.userCheckedId = []
                this.order.forEach(item => {
                    this.userCheckedId.push(item.id)
                })
                this.supplierIds = []
                this.handleList.forEach(item => {
                    this.supplierIds.push(item[0].supplier_id)
                })
            }
        },
        deleteCar(){
          console.log('in deleteCar: ', this.userCheckedId);
            if(this.userCheckedId.length){
                Dialog.confirm({
                    title: '提示',
                    message: '是否确认删除该商品？',
                }).then(() => {
                    let newCar = {}
                    let nowCar = this.order.filter(item=>{
                        if(this.userCheckedId.indexOf(item.id) == -1){
                            return item
                        }
                    })
                    this.order = nowCar
                    this.handleList = handleOrderList(nowCar)
                    this.setShopCarNum(nowCar.length)
                    newCar[this.uid] = nowCar
                    localStorage.setItem('shopCarInfo',JSON.stringify(newCar))
                    this.userCheckedId = []
                    Toast.success('删除成功');
                }).catch(() => {
                    return
                });
                
            }else{
                Toast.fail('请选择一个需要删除的商品')
            }
            
        },
        addShop(id){
            this.order.forEach(item=>{
                if(item.id == id){
                    item.num++
                }
            })
            let nowCar = {}
            nowCar[this.uid] = this.order
            this.countPrice()
            localStorage.setItem("shopCarInfo",JSON.stringify(nowCar))
        },
        reduceShop(id){
            this.order.forEach(item=>{
                if(item.id == id){
                    if(item.num>1){
                        item.num--
                    }
                }
            })
            let nowCar = {}
            nowCar[this.uid] = this.order
            this.countPrice()
            localStorage.setItem("shopCarInfo",JSON.stringify(nowCar))
        },
        // 结算
        toAccount(){
            // Toast('开发中')
            // return
            // 没有商品不能结算，不用验证登录态
            if(this.userCheckedId.length){
                // if(JSON.parse(localStorage.getItem('data')).cloud_vip){
                    this.$router.push({
                        path:'submitOrder',
                        query:{
                            userCheckedId:this.userCheckedId,
                            vip_price:this.vip_price,
                            all_price:this.all_price
                        }
                    })
                // }else{
                //     // Toast.fail('仅云仓会员可以购买商品')
                //     Dialog.confirm({
                //         message: '您还不是云仓会员，无法购买商品',
                //         confirmButtonText: '去开通云仓会员',
                //         showCancelButton: false,
                //         closeOnClickOverlay: true
                //     }).then(() => {
                //         location.href = './cloudProduct.html'
                //     }).catch(() => {});
                //     return
                // }
            }else{
                Toast.fail('请至少选择一个商品')
            }
        },
        // 进入商品详情
        toDetail(ids,type,supplier_id){
            this.$router.push({
                path:'productDetails',
                query:{
                    com_ids:ids.toString(),
                    supplier_id:supplier_id,
                    att:type
                }
            })
        }
    },
    watch:{
        'userCheckedId':function(){
            let cL = this.userCheckedId.length
            let cal = this.order.length
            if(cL === cal){
                this.checkedAll = true
            }else{
                this.checkedAll = false
            }
            this.countPrice()
        },
        'supplierIds':function(){
            let chl = this.handleList.length
            let csl = this.supplierIds.length
            if(chl === csl){
                this.checkedAll = true
            }else{
                this.checkedAll = false
            }
            this.countPrice()
        },
        'order':function(){
            let newCar = {}
            newCar[this.uid] = this.order
            // console.log(this.order)
            localStorage.setItem("shopCarInfo",JSON.stringify(newCar))
        }
    }
}
</script>